import React, { useEffect, useRef } from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import drupalApi from '@futures-platform/connectors/drupal-api'

const HubpotForm = ({radarSettings}) => {
    const formRef = useRef(null)
    const setTimeoutRef = useRef(null)
    const userNameRef = useRef(null)

    React.useEffect(() => {
        // const groupRequest = drupalApi.getGroups()
        const membershipRequest = drupalApi.getMemberships()
    
        membershipRequest.then(groups => {
          userNameRef.current = groups?.length ? groups[0]?.email : ''
        })
        .catch(err => {
            // dispatch(error(err))
        })
      }, [])
    const { loaded, error, formCreated } = useHubspotForm({
        target: '#my-hubspot-form',
        region: "na1",
        portalId: "4855330",
        formId: "9834e0e5-36b0-4d80-b6eb-4282846ffd91",
        version: "V2_PRERELEASE"
    });
    
    useEffect(() => {
        // const a = event => {
        //     if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        //         formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').value = userEmail
        //         formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_group_id"]').value = radarSettings?.group?.id
        //         formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_radar_id"]').value = radarSettings?.radar_id;
        //     }
        //  };
        if (!!formCreated && !!loaded && !!formRef.current && !error) {
            setTimeoutRef.current = setTimeout(function(){
                try {
                    // window.addEventListener('message', a, false)
                    // const title = ((radarSettings?.radarLanguage || '') === 'en') ? 'Request a shared link' : 'Pyydä jaettava linkki'
                    const newNode = document.createElement("h3");
                    const title = 'Request a shared link'
                    // Create a text node:
                    const textNode = document.createTextNode(title);
                    newNode.appendChild(textNode);
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector(".hbspt-form").prepend(newNode)
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').value = userNameRef.current
                    

                    // formRef.current.querySelector('iframe').contentWindow.document.querySelector(".hs-email").innerHTML +=`<h5>${userEmail}</h5>`
                    // formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').style.display = 'none';
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').setAttribute("value", userNameRef.current);
                    // formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').disabled = true;
                    // formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').style.color='rgb(96 96 96)'

                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_group_id"]').value = radarSettings?.group?.id
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_group_id"').setAttribute("value", radarSettings?.group?.id);
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('.hs_go2_group_id').style.display = 'none';

                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_radar_id"]').value = radarSettings?.radar_id;
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_radar_id"]').setAttribute("value", radarSettings?.radar_id);
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('.hs_go2_radar_id').style.display = 'none';

                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="email"]').dispatchEvent(new Event('input', { bubbles: true }));
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_radar_id"]').dispatchEvent(new Event('input', { bubbles: true }));
                    formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="go2_group_id"]').dispatchEvent(new Event('input', { bubbles: true }));
                    



                } catch (error) {
                    
                }
               
                // formRef.current.querySelector('iframe').contentWindow.document.querySelector('input[name="drupal_group_name"]').value = radarSettings?.group?.title
            }, 1000)
        }
        return () => {
            clearTimeout(setTimeoutRef.current)
            // window.removeEventListener('message', a , false)
        }

        
    }, [formCreated, loaded, error])


    return (
        <div style={{padding: '24px'}} ref={formRef} id="my-hubspot-form"></div>
    )
}

export default HubpotForm